<template>
  <div class="secondary-main-container">
    <section class="main-width secondary-view">
      <div class="secondary-sidebar">
        <div class="secondary-menu">
          <header-menu class="header-menu" @clickMenu="clickMenu"></header-menu>
        </div>
        <Sidebar ref="SecondarySideBarRef" class="secondary-el-menu" :style="{display}" :sidebarRouters="sidebarRouters" :key="key" />
      </div>
      <div class="secondary-router-view">
        <transition name="fade-transform" mode="out-in">
          <router-view :key="key" />
        </transition>
      </div>
    </section>
  </div>

</template>

<script>
import { constantRoutes } from "@/router/routes";
import sideNavRouter from "./sideBar/sideNavRouter";
import HeaderMenu from "@/components/common/headerMenu.vue"

import Sidebar from "./sideBar/index";

export default {
  name: "AppMain",
  data() {
    return {
      sidebarRouters: [],
      display: "block",
    }
  },
  props: {},
  components: { Sidebar, HeaderMenu },
  computed: {
    key() {
      return this.$route.path
    }
  },
  watch: {
    $route: {
      handler() {
        this.initPage();
      }
    }
  },
  mounted() {
    this.scrollListen();
    window.addEventListener('resize', this.scrollListen);
    this.initPage();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.scrollListen);
  },
  methods: {
    initPage() {
      let currentRouter = this.$route.path.replace(/\/\//g, "/");
      // 项目结构仅有一个路由下有二级路由，特殊处理
      let navRouter = constantRoutes.find(item => item.headerNav);
      let navRouterPath = navRouter.path; // 导航父级path
      let navList = navRouter.children; // 全部导航
      let currentRouterChildren = currentRouter && currentRouter.replace(/\/views\//, ""); // 当前页面路由
      let currentPath = currentRouterChildren && currentRouterChildren.split("/")[0]; // 当前页面上级path
      this.sidebarRouters = sideNavRouter[navRouterPath + "/" + currentPath].router;
    },

    clickMenu(active) {
      this.display = active ? "block" : "none";
    },

    scrollListen() {
      const windowWidth = window.innerWidth;
      if (windowWidth < 1200) {
        this.display = "none";
      } else {
        this.display = "block";
      }
    }
  },
  watch: {
    "$route": {
      handler() {
        this.$nextTick(() => {
          this.scrollListen();
          this.initPage();
        })
      },
      immediate: true,
      deep: true
    }
  },
}
</script>

<style lang="less">
.secondary-main-container {
  width: 100%;
  .secondary-view {
    display: flex;
  }
  .secondary-sidebar {
    width: 275px;
    min-height: 300px;
    background: #f8f9fa;
    padding: 20px;
    .secondary-menu {
      display: none;
    }
    .secondary-el-menu {
      display: block;
    }
  }
  .secondary-router-view {
    width: calc(100% - 275px);
    flex: 1;
    padding: 10px 30px;
  }
}

@media screen and (max-width: 768px) {
  .secondary-main-container {
    width: 100%;
    .secondary-view {
      display: flex;
      flex-direction: column;
    }
    .secondary-sidebar {
      width: 100%;
      min-height: auto;
      background: #f8f9fa;
      padding: 14px;
      display: flex;
      .secondary-menu {
        display: block;
        margin-right: 14px;
        .hamburger .line {
          background-color: #666;
        }
      }
      .secondary-el-menu {
        flex: 1;
        display: none;
      }
    }
    .secondary-router-view {
      width: 100%;
      flex: 1;
      padding: 14px 0;
      > div > h2 {
        font-weight: 600;
        font-size: 20px;
        line-height: 34px;
        text-align: center;
        color: #212529;
        margin-bottom: 20px;
      }
    }
  }
}
</style>